// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

let dropdowns = [];

const closeAllDropdowns = event => {
    dropdowns.each(function (dropdown) {
        if (dropdown.isOpened(event)) {
            dropdown.close(event);
        }
    });
};

/**
 * @class Jsw.DropdownManager
 * @singleton
 */
export const DropdownManager = (function () {
    return {
        /**
         * Register dropdown component.
         * @param {Element} toggler
         * @param {Function} isOpened
         * @param {Function} open
         * @param {Function} close
         * @param {Function} [beforeClick]
         * @returns {Object}
         */
        register(toggler, isOpened, open, close, beforeClick) {
            const dropdown = {
                toggler,
                isOpened,
                open,
                close,
                handler(event) {
                    if (beforeClick && !beforeClick(event)) {
                        return;
                    }
                    event.stopPropagation();
                    const oldIsOpened = isOpened(event);
                    closeAllDropdowns(event);
                    if (!oldIsOpened) {
                        open(event);
                    }
                },
            };

            dropdowns.push(dropdown);
            dropdown.toggler.observe('click', dropdown.handler);

            if (dropdowns.length > 0) {
                $(document.body).observe('click', closeAllDropdowns);
            }

            return dropdown;
        },

        /**
         * Un register dropdown component.
         * @param {Object} dropdown
         */
        unregister(dropdown) {
            dropdown.toggler.stopObserving('click', dropdown.handler);
            dropdowns = dropdowns.without(dropdown);

            if (dropdowns.length === 0) {
                $(document.body).stopObserving('click', closeAllDropdowns);
            }
        },
    };
}());



// WEBPACK FOOTER //
// ./jsw/dropdown-manager.js